import {
  getObject,
} from "@surya-digital/leo-ts-types";
import { BoundedName, BoundedNameDTO } from "../types/boundedName";
import { TemplateContent, TemplateContentDTO } from "./templateContent";

export interface EmailContentDTO {
  subject: BoundedNameDTO;
  body: TemplateContentDTO;
}

export class EmailContent {
  readonly isEmailContentEmailContent: boolean = true;

  readonly subject: BoundedName;
  readonly body: TemplateContent;


  constructor(
  subject: BoundedName, 
  body: TemplateContent
  ) {
    this.subject = subject;
    this.body = body;
  }

  static fromDTO(dto: EmailContentDTO): EmailContent {
    const subject = BoundedName.fromDTO(getObject(dto, "subject", InvalidEmailContentSubjectError));
    const body = TemplateContent.fromDTO(getObject(dto, "body", InvalidEmailContentBodyError));
    return new EmailContent(
      subject,
      body
    );
  }

  toDTO(): EmailContentDTO {
    const dto: EmailContentDTO = {
        subject: this.subject.toDTO(),
        body: this.body.toDTO()
    };
    return dto;
  }
  }

EmailContent.prototype.toString = function toString(): string {
  return `EmailContent(subject='${this.subject}',body='${this.body}')`;
};

export class InvalidEmailContentError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailContentError";
  }
}
export class InvalidEmailContentSubjectError extends InvalidEmailContentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailContentSubjectError";
  }
}

export class InvalidEmailContentBodyError extends InvalidEmailContentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailContentBodyError";
  }
}
